module.exports = __webpack_public_path__ + "static/media/FACC_Concept2.a9bde685.docx";